import { createFileRoute, ClientOnly } from '@tanstack/react-router';
import '@livekit/components-styles';
import '@livekit/components-styles/prefabs';
import RoomPage from '@/components/RecordingView/Room';

export const Route = createFileRoute('/recording-view')({
  component: Page,
});

export function Page() {
  console.log(import.meta.env.VITE_REACT_APP_LIVEKIT_URL);
  return (
    <div className="container">
      <ClientOnly fallback={<div>Loading room...</div>}>
        <RoomPage
          // EgressHelper retrieves parameters passed to the page
          url={import.meta.env.VITE_REACT_APP_LIVEKIT_URL}
          layout={'single-speaker'}
        />
      </ClientOnly>
    </div>
  );
}
